import React, {useEffect} from 'react'
import MainDetails from '../../Components/Customers/MainDetails'
import getServices from '../../Services/get-service';

function Customers() {

  //   useEffect( ()=>{

  //      const getAlluser = async ()=>{
  //       console.log('I was called get users ');
  //       const response = await getServices.getAllUserHalal()
     
  //       console.log('all user from customer ', response)

  //     }

  //     getAlluser()
 
  // },[])

  return (
    <div>
    <MainDetails/>
    </div>
  )
}

export default Customers